import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { push } from 'connected-react-router';

import NavigationCard from "./NavigationCard";

import useDataSource from "../../../../hooks/useDataSource";
import Construct from "../../Construct";

import { styled, Grid, LinearProgress } from '@mui/material';

const PREFIX = 'NavigationCards';

const classes = {
    root: `${PREFIX}-root`,
    navigationCards: `${PREFIX}-navigationCards`,
    linearProgress: `${PREFIX}-linearProgress`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%'
    },

    [`& .${classes.navigationCards}`]: {
        // flex: 'auto',
        height: '100%',
        width: '100%',
        zIndex: '50'
    },

    [`& .${classes.linearProgress}`]: {
        height: '1px'
    }
}));

export default function NavigationCards({configuration}) {

    const dispatch = useDispatch();

    // console.log('NavigationCards:render()');
    const dataSourceName = configuration.dataSource?.name ? configuration.dataSource.name : '';
    const key = configuration.dataSource?.key ? configuration.dataSource.key : '';

    // App State
    // const config = useSelector(state => state.config);
    const viewStaged = useSelector(state => state.data.viewStaged);
    const dataSource = useDataSource(dataSourceName);

    // Component State
    const [cards, setCards] = useState([]);

    useEffect( () => {
        // console.log('NavigationCards: UseEffect, [dataSource.data]');

        if (dataSource.data) {
            if (dataSource.data.length === 1) {
                const row = dataSource.data[0];
                // console.log('push ln 51 navigation cards');
                dispatch(push('/details?id={0}'.format(row[key])));
            }
            else {
                const compiledCardArray = [];
                for (let p = 0; p < dataSource.data.length; p++) {
                    const project = dataSource.data[p];
                    compiledCardArray.push(
                        <div key={project[key]}>
                            <NavigationCard data={project} cardKeyField={key} viewStaged={viewStaged}/>
                        </div>
                    );
                }
                setCards(compiledCardArray);
            }
        }
    }, [dataSource.data]);

    return (
        <Root className={classes.root}>
            {dataSource.fetching &&
            <LinearProgress className={classes.linearProgress}/>
            }
            {!dataSource.fetching &&
            <div className={classes.linearProgress}></div>
            }

            {configuration.element.summary &&
                // NOTE: They way this is currently exposed the
                // json cannot set sticky of the parent so we do it here
                // In future when the card selector is 100% data driven then
                // we'll address it then
                <div style={{position: "sticky", top: "0", zIndex: "99"}}>
                <Construct layout={{configuration: configuration.element.summary}}/>
                </div>
            }

            {/* Navigation Cards */}
            <div className={classes.navigationCards}>
                <Grid container justifyContent={"center"}>
                    <Grid item style={{width: '100%'}}>
                        {cards}
                    </Grid>
                </Grid>
            </div>

        </Root>
    );
}
